import _ from 'lodash';
import React from 'react';

import { Organization, Project } from '../../../types/entities';
import { SidebarMenuItemLink } from '../sidebar-menu-item-link/sidebar-menu-item-link';
import { SidebarMenuItem } from '../sidebar.types';

import {
  SidebarBackButton,
  SidebarDivider,
  SidebarSectionItem,
} from '@wix/design-system';
import { ProjectSelectTooltip } from '../project-select-tooltip/project-select-tooltip';

interface SidebarProjectLevelMenu {
  projectLevelMenuItems: SidebarMenuItem[];
  project: Project;
  projects: Project[];
  organization: Organization;
  selectedMenuItemId: string;
  onBackHandler(): void;
}

export const SidebarProjectLevelMenu = ({
  project,
  projects,
  organization,
  selectedMenuItemId,
  onBackHandler,
  projectLevelMenuItems,
}: SidebarProjectLevelMenu) => {
  return (
    !_.isEmpty(project) && (
      <>
        <SidebarBackButton onClick={onBackHandler}>
          {`back to ${organization.name}`}
        </SidebarBackButton>
        <SidebarDivider />
        <SidebarSectionItem disabled>
          <ProjectSelectTooltip project={project} projects={projects} />
        </SidebarSectionItem>
        <SidebarDivider />
        {projectLevelMenuItems.map((menuItem) => (
          <SidebarMenuItemLink
            menuItem={menuItem}
            key={menuItem.id}
            isActive={menuItem.id === selectedMenuItemId}
          />
        ))}
      </>
    )
  );
};
